<span [ngClass]="hostClasses" [style.width]="styleWidth">
  <ng-content *ngIf="!loading; else loadingTpl"></ng-content>
  <ng-template #loadingTpl>{{ loadingText }}</ng-template>
</span>
